
export default "/assets/pushpin-fill.a0ba6d92.svg"